// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-monitor-panel{
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;

}
.monitor-panel-header{
    position: absolute;
    /* background-color: rgba(228, 228, 228, 0.774); */
    background-color: rgba(255, 255, 255, 0.6);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    top: 0px;
    display: flex;
    flex-direction: row;
    height: 15%;
    width: 100%;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    z-index: 10;
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.1);
}
.monitor-panel-header-compact{
    position: relative;
    height: 90%;
    width: 95%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items : center;
    
}
.cont-info-panel-monitor{
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 15%;
    justify-content: center;
    align-items : center;
    padding-left: 10px;
 
}
.compact-info-panel-monitor{
    display: flex;
    flex-direction: column;
    height: 80%;
    width: 90%;
    justify-content: center;
    align-items : center;
    padding: 5px;
    box-sizing: border-box;
    background-color: var(--white-color);
    border-radius: var(--border-radios-small, 10px);
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.15);
    text-align: center;
}
.compact-info-panel-monitor:hover{
    cursor: pointer;
    box-shadow: 3px 3px 15px rgba(67, 67, 67, 0.3);
}
.compact-info-panel-monitor.total{
     background-color: transparent;
     color: var(--main-color);
     border: 1px solid var(--main-color);
}
.compact-info-panel-monitor.up{
     background-color: transparent;
     color: var(--green);
     border: 1px solid var(--green);
}
.compact-info-panel-monitor.down{
     background-color: transparent;
     color: #ee0808;
     border: 1px solid #ee0808;
}
.compact-info-panel-monitor.unknown{
     background-color: transparent;
     color: #5c5c5c;
     border: 1px solid #5c5c5c;
}
.compact-info-panel-monitor.generals{
     background-color: transparent; /* O var(--white-color) si hace falta */
     color: var(--main-color);
     border: 1px solid var(--main-color);
     width: 70%;
     display: flex;
     flex-direction: row;
}
.divisor-genrales-panel-monitor{
    position: relative;
    width: 33%;
    height: 100%;
    display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     color: var(--txt-color);
}
.divisor-genrales-panel-monitor.mtto{
    padding: 2px 4px;
    color: rgb(255, 174, 0);
    background-color: transparent;
    border: 1px solid rgb(255, 174, 0);
    border-radius: 5px;
    margin: 0 2px;
}
.divisor-genrales-panel-monitor.except{
    padding: 2px 4px;
    color: purple;
    background-color: transparent;
    border: 1px solid purple;
    border-radius: 5px;
    margin: 0 2px;
}

.line-divisor-vertical {
  border: none;
  height: 90%;
  width: 1px;
  background-color: #ddd;
  margin-bottom: unset;
  margin-top: unset;
}
.info-header-panel-monitor{
    height: 30% ;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; /* cambiado a centrado */
    font-weight: bold;
    word-break: break-word;
    white-space: normal;
    line-height: 1.1;
    box-sizing: border-box;
}
.info-body-panel-monitor{
    height: 40% ;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; /* cambiado a centrado */
    box-sizing: border-box;
}
.info-footer-panel-monitor{
    height: 30% ;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; /* cambiado a centrado */
    box-sizing: border-box;
}
.info-icons-panel-monitor{
   height: 80% ;
    width: 30%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.info-number-panel-monitor{
   height: 100% ;
    width: 40%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 20px;
}
.line-footer-panel-monitor{
    border: none;
    height: 1px;
    width: 90%;
    background-color: #ddd;
    margin-bottom: unset;
    margin-top: unset;
}
.info-percent-panel-monitor{
   height: 100% ;
    width: 60%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.info-percent-panel-monitor span{
   border-radius: 5px;
   padding: 5%;
}
.info-percent-panel-monitor.up span{
   background-color: #afd4b2;
}
.info-percent-panel-monitor.down span{
   background-color: #e6bdbd;
}
.info-percent-panel-monitor.unknown span{
   background-color: #b4b4b4;
}
.info-percent-panel-monitor.mtto span{
   background-color: rgba(255, 174, 0, 0.199);
   color: rgba(167, 114, 2, 0.712);
}

.info-percent-panel-monitor.except span{
   background-color: rgba(128, 0, 128, 0.233);
   color: rgba(102, 1, 102, 0.692);
}








.monitor-panel-body{
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
}
.monitor-panel-filter-container{

        position: absolute;
        left: 0px;
        top: 15%;
        height: 80%;
        width: 25%;
        z-index: 5;
        border-radius: 0px 0px 20px 0px;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        box-shadow: 3px 0px 10px rgba(67, 67, 67, 0.1);
        background-color: rgba(255, 255, 255, 0.7);
        -webkit-backdrop-filter: blur(10px);
                backdrop-filter: blur(10px);
        color: var(--txt-color);
}
.monitor-panel-filter-container.close{
    position: absolute;
        left: 0px;
        top: 15%;
        height: 7%;
        width: 10%;
        border-radius: 0px 0px 20px 0px;
}

.monitor-panel-filter-header{
    display: flex;
    flex-direction: row;
    height: 10%;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    /* border-bottom: 1px solid #ddd; */
    padding-left: 10px;
}
.monitor-panel-filter-header.close{
    height: 100%;
    border-bottom: unset
}
.monitor-panel-filter-title-text{
font-weight: bold;
    font-size: 16px;
    letter-spacing: 1px;
    color: #3f3f3f;
}
.monitor-panel-filter-title-img{
    height: 20px;
    width: 20px;
    /* background-image: url('/icons/filtros.png'); */
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 10px;
}
.monitor-panel-filter-body{
    display: flex;
    flex-direction: column;
    height: 90%;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    overflow-y: auto;
    padding: 10px;
}

.point-title{
    height: 0.375rem;
    width: 0.375rem;
    border-radius: 50%;
}
.point-title.up{
    background-color: rgb(34,197,94);
}
.point-title.down{
    background-color: rgb(199, 57, 57);
}
.point-title.unknown{
    background-color: rgb(112, 112, 112);
}
.monitor-panel-map-container{
        position: relative;
        right: 0px;
        top: 0px;
        height: 100%;
        width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/AfiliationMap/styles/panel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;;AAE3B;AACA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,0CAA0C;IAC1C,mCAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,WAAW;IACX,8CAA8C;AAClD;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;;AAExB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;;AAEtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;IACtB,oCAAoC;IACpC,+CAA+C;IAC/C,oCAAoC;IACpC,+CAA+C;IAC/C,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,8CAA8C;AAClD;AACA;KACK,6BAA6B;KAC7B,wBAAwB;KACxB,mCAAmC;AACxC;AACA;KACK,6BAA6B;KAC7B,mBAAmB;KACnB,8BAA8B;AACnC;AACA;KACK,6BAA6B;KAC7B,cAAc;KACd,yBAAyB;AAC9B;AACA;KACK,6BAA6B;KAC7B,cAAc;KACd,yBAAyB;AAC9B;AACA;KACK,6BAA6B,EAAE,uCAAuC;KACtE,wBAAwB;KACxB,mCAAmC;KACnC,UAAU;KACV,aAAa;KACb,mBAAmB;AACxB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;KACZ,sBAAsB;KACtB,uBAAuB;KACvB,mBAAmB;KACnB,uBAAuB;AAC5B;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB,EAAE,wBAAwB;IACjD,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB,EAAE,wBAAwB;IACjD,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB,EAAE,wBAAwB;IACjD,sBAAsB;AAC1B;AACA;GACG,YAAY;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;GACG,aAAa;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;AACrB;AACA;GACG,aAAa;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;GACG,kBAAkB;GAClB,WAAW;AACd;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,0CAA0C;GAC1C,+BAA+B;AAClC;;AAEA;GACG,0CAA0C;GAC1C,+BAA+B;AAClC;;;;;;;;;AASA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;QAEQ,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,WAAW;QACX,UAAU;QACV,UAAU;QACV,+BAA+B;QAC/B,0CAA0C;QAC1C,8CAA8C;QAC9C,0CAA0C;QAC1C,mCAA2B;gBAA3B,2BAA2B;QAC3B,uBAAuB;AAC/B;AACA;IACI,kBAAkB;QACd,SAAS;QACT,QAAQ;QACR,UAAU;QACV,UAAU;QACV,+BAA+B;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ;AACJ;AACA;AACA,iBAAiB;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,WAAW;IACX,iDAAiD;IACjD,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,oCAAoC;AACxC;AACA;QACQ,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,YAAY;QACZ,WAAW;AACnB","sourcesContent":[".main-monitor-panel{\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n.monitor-panel-header{\r\n    position: absolute;\r\n    /* background-color: rgba(228, 228, 228, 0.774); */\r\n    background-color: rgba(255, 255, 255, 0.6);\r\n    backdrop-filter: blur(10px);\r\n    top: 0px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 15%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-bottom: 1px solid rgba(0,0,0,0.1);\r\n    z-index: 10;\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.1);\r\n}\r\n.monitor-panel-header-compact{\r\n    position: relative;\r\n    height: 90%;\r\n    width: 95%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    align-items : center;\r\n    \r\n}\r\n.cont-info-panel-monitor{\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100%;\r\n    width: 15%;\r\n    justify-content: center;\r\n    align-items : center;\r\n    padding-left: 10px;\r\n \r\n}\r\n.compact-info-panel-monitor{\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 80%;\r\n    width: 90%;\r\n    justify-content: center;\r\n    align-items : center;\r\n    padding: 5px;\r\n    box-sizing: border-box;\r\n    background-color: var(--white-color);\r\n    border-radius: var(--border-radios-small, 10px);\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.15);\r\n    text-align: center;\r\n}\r\n.compact-info-panel-monitor:hover{\r\n    cursor: pointer;\r\n    box-shadow: 3px 3px 15px rgba(67, 67, 67, 0.3);\r\n}\r\n.compact-info-panel-monitor.total{\r\n     background-color: transparent;\r\n     color: var(--main-color);\r\n     border: 1px solid var(--main-color);\r\n}\r\n.compact-info-panel-monitor.up{\r\n     background-color: transparent;\r\n     color: var(--green);\r\n     border: 1px solid var(--green);\r\n}\r\n.compact-info-panel-monitor.down{\r\n     background-color: transparent;\r\n     color: #ee0808;\r\n     border: 1px solid #ee0808;\r\n}\r\n.compact-info-panel-monitor.unknown{\r\n     background-color: transparent;\r\n     color: #5c5c5c;\r\n     border: 1px solid #5c5c5c;\r\n}\r\n.compact-info-panel-monitor.generals{\r\n     background-color: transparent; /* O var(--white-color) si hace falta */\r\n     color: var(--main-color);\r\n     border: 1px solid var(--main-color);\r\n     width: 70%;\r\n     display: flex;\r\n     flex-direction: row;\r\n}\r\n.divisor-genrales-panel-monitor{\r\n    position: relative;\r\n    width: 33%;\r\n    height: 100%;\r\n    display: flex;\r\n     flex-direction: column;\r\n     justify-content: center;\r\n     align-items: center;\r\n     color: var(--txt-color);\r\n}\r\n.divisor-genrales-panel-monitor.mtto{\r\n    padding: 2px 4px;\r\n    color: rgb(255, 174, 0);\r\n    background-color: transparent;\r\n    border: 1px solid rgb(255, 174, 0);\r\n    border-radius: 5px;\r\n    margin: 0 2px;\r\n}\r\n.divisor-genrales-panel-monitor.except{\r\n    padding: 2px 4px;\r\n    color: purple;\r\n    background-color: transparent;\r\n    border: 1px solid purple;\r\n    border-radius: 5px;\r\n    margin: 0 2px;\r\n}\r\n\r\n.line-divisor-vertical {\r\n  border: none;\r\n  height: 90%;\r\n  width: 1px;\r\n  background-color: #ddd;\r\n  margin-bottom: unset;\r\n  margin-top: unset;\r\n}\r\n.info-header-panel-monitor{\r\n    height: 30% ;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center; /* cambiado a centrado */\r\n    font-weight: bold;\r\n    word-break: break-word;\r\n    white-space: normal;\r\n    line-height: 1.1;\r\n    box-sizing: border-box;\r\n}\r\n.info-body-panel-monitor{\r\n    height: 40% ;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center; /* cambiado a centrado */\r\n    box-sizing: border-box;\r\n}\r\n.info-footer-panel-monitor{\r\n    height: 30% ;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center; /* cambiado a centrado */\r\n    box-sizing: border-box;\r\n}\r\n.info-icons-panel-monitor{\r\n   height: 80% ;\r\n    width: 30%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 12px;\r\n}\r\n.info-number-panel-monitor{\r\n   height: 100% ;\r\n    width: 40%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n}\r\n.line-footer-panel-monitor{\r\n    border: none;\r\n    height: 1px;\r\n    width: 90%;\r\n    background-color: #ddd;\r\n    margin-bottom: unset;\r\n    margin-top: unset;\r\n}\r\n.info-percent-panel-monitor{\r\n   height: 100% ;\r\n    width: 60%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 12px;\r\n}\r\n.info-percent-panel-monitor span{\r\n   border-radius: 5px;\r\n   padding: 5%;\r\n}\r\n.info-percent-panel-monitor.up span{\r\n   background-color: #afd4b2;\r\n}\r\n.info-percent-panel-monitor.down span{\r\n   background-color: #e6bdbd;\r\n}\r\n.info-percent-panel-monitor.unknown span{\r\n   background-color: #b4b4b4;\r\n}\r\n.info-percent-panel-monitor.mtto span{\r\n   background-color: rgba(255, 174, 0, 0.199);\r\n   color: rgba(167, 114, 2, 0.712);\r\n}\r\n\r\n.info-percent-panel-monitor.except span{\r\n   background-color: rgba(128, 0, 128, 0.233);\r\n   color: rgba(102, 1, 102, 0.692);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.monitor-panel-body{\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.monitor-panel-filter-container{\r\n\r\n        position: absolute;\r\n        left: 0px;\r\n        top: 15%;\r\n        height: 80%;\r\n        width: 25%;\r\n        z-index: 5;\r\n        border-radius: 0px 0px 20px 0px;\r\n        border-right: 1px solid rgba(0, 0, 0, 0.1);\r\n        box-shadow: 3px 0px 10px rgba(67, 67, 67, 0.1);\r\n        background-color: rgba(255, 255, 255, 0.7);\r\n        backdrop-filter: blur(10px);\r\n        color: var(--txt-color);\r\n}\r\n.monitor-panel-filter-container.close{\r\n    position: absolute;\r\n        left: 0px;\r\n        top: 15%;\r\n        height: 7%;\r\n        width: 10%;\r\n        border-radius: 0px 0px 20px 0px;\r\n}\r\n\r\n.monitor-panel-filter-header{\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 10%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    cursor: pointer;\r\n    /* border-bottom: 1px solid #ddd; */\r\n    padding-left: 10px;\r\n}\r\n.monitor-panel-filter-header.close{\r\n    height: 100%;\r\n    border-bottom: unset\r\n}\r\n.monitor-panel-filter-title-text{\r\nfont-weight: bold;\r\n    font-size: 16px;\r\n    letter-spacing: 1px;\r\n    color: #3f3f3f;\r\n}\r\n.monitor-panel-filter-title-img{\r\n    height: 20px;\r\n    width: 20px;\r\n    /* background-image: url('/icons/filtros.png'); */\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    margin-right: 10px;\r\n}\r\n.monitor-panel-filter-body{\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 90%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    overflow-y: auto;\r\n    padding: 10px;\r\n}\r\n\r\n.point-title{\r\n    height: 0.375rem;\r\n    width: 0.375rem;\r\n    border-radius: 50%;\r\n}\r\n.point-title.up{\r\n    background-color: rgb(34,197,94);\r\n}\r\n.point-title.down{\r\n    background-color: rgb(199, 57, 57);\r\n}\r\n.point-title.unknown{\r\n    background-color: rgb(112, 112, 112);\r\n}\r\n.monitor-panel-map-container{\r\n        position: relative;\r\n        right: 0px;\r\n        top: 0px;\r\n        height: 100%;\r\n        width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
